import { FC } from "react";
import { Logo } from "../../../assets/images";
import "./Loader.style.scss";

const Loader: FC = () => {
  return (
    <div className="loader">
      <div className="loader_child">
        <img
          src={Logo}
          alt="logo"
          className="loader_logo"
          loading="eager"
        />
      </div>
    </div>
  );
};

export default Loader;
